import * as next from '../../../types/next'
import { getBlockNameByScope } from '../../../utils'
import { CONTROL_NAME } from '../../../utils/blocks/types'
import type { UpBlockHandler } from '../types'
import { newId } from '../utils'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.HyperlinkBlock> = (uischema, schema) => {
  if (uischema.type !== CONTROL_NAME.SECONDARY_ACTION_BAR_CONTROL) {
    throw new Error('Expected a valid SecondaryActionBar control')
  }

  const blockName = getBlockNameByScope(uischema.scope)

  if (!blockName) {
    throw new Error('Expected a valid block name')
  }

  const items = ((uischema.options?.optionsLabels as string[]) ?? []).reduce<
    next.HyperlinkBlock['settings']['items']
  >((acc, label, index) => {
    const url = schema.properties?.[blockName]?.enum?.[index]

    if (!url) {
      throw new Error(`Expected an existing URL for Option #${index}`)
    }

    acc[newId<next.HyperlinkItemId>()] = {
      url,
      label,
      orderIndex: index
    }

    return acc
  }, {})

  return {
    type: next.BLOCK_TYPE.HYPERLINK,
    settings: {
      ...upCommonSettings(uischema),
      items
    },
    references: {}
  }
}
